import { useState } from 'react'
import { LoginFormImport } from './Import'
const { RoutesMap, Form, InputGroup, Button, Card, logo, icon, useFormik, LoginSchema, useNavigate, useDispatch, toast, KeyRound, UserRound, Eye, EyeOff, ButtonLoader, SessionManager, signIn, sidebar } = LoginFormImport

export default function UserLoginForm(props) {

  const { setTogggle } = props

  const [spinner, setSpinner] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const initialValues = {
    phone: '',
    password: '',
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: initialValues,
    validationSchema: LoginSchema,

    onSubmit: (values, action) => {
      // console.log(values)
      setSpinner(true)
      dispatch(signIn(values)).then((res) => signIn_user(res.payload, action))
    },
  })

  const signIn_user = (res, action) => {

    if (res?.status === 200) {
      console.log(res)
      SessionManager.setCookie('user_token', `Bearer ${res?.data?.data?.token}`, 3)
      SessionManager.setCookie('user', res?.data?.data && JSON.stringify(res?.data?.data), 3)

      toast.success("SignIn Successfully!!..", { position: "bottom-right" })

      dispatch(sidebar({ navigate })).then((res1) => sidebar_res(res1.payload))

    } else if (res?.status === 400) {
      setSpinner(false)
      toast.error(res?.data?.message, { position: "bottom-right" })
    } else if (res?.status === 500) {
      setSpinner(false)
      toast.error("Server error!!..", { position: "bottom-right" })
    } else {
      setSpinner(false)
      toast.error("Something went wrong!!..", { position: "bottom-right" })
    }
  }

  const sidebar_res = (res) => {
    if (res?.status === 200) {
      const permission = res?.data?.data?.attributes?.map(val => JSON.parse(val)).flat()
      SessionManager.setSession('permission', JSON.stringify(permission))
      navigate(RoutesMap.DASHBOARD.path)
      setSpinner(false)
    } else {
      setSpinner(false)
    }
  }

  return (
    <>
      <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className='h-100'>
        <Card className="h-100 rounded-start-5 rounded-end-0" style={{ backgroundColor: '#F8FAFC' }}>
          <Card.Header className="p-3 text-end" style={{ backgroundColor: 'unset' }}>
            <span className='fs-6 text-muted'>Don't have an account?
              <u className='fw-medium teal' style={{ cursor: 'pointer' }} onClick={() => setTogggle(true)}> Sign Up</u>
            </span>
          </Card.Header>
          <Card.Body className='px-5 py-5 d-flex align-items-center'>
            <div className='flex-fill'>
              <img src={logo} alt="logo" className='img-fluid' style={{ height: '80px' }} />
              <div className='mt-4 mb-2'>
                <h3 className='teal'>Sign In to Continue</h3>
                <p>Let's get started !!...</p>
              </div>

              <div className='mb-2'>
                <Form.Label className='fw-medium mb-1' style={{ color: '#001529' }}>{'Username'}</Form.Label>
                <InputGroup className="" size="sm">
                  <InputGroup.Text id="phone"><UserRound size={18} /></InputGroup.Text>
                  <Form.Control
                    className='login-input'
                    placeholder="Enter Your Username"
                    aria-label="Phone"
                    aria-describedby="phone"
                    name='phone'
                    value={values.phone || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </InputGroup>
                {errors.phone && touched.phone ? (<span className='field_error'>{errors.phone}</span>) : null}
              </div>

              <div className='mb-2'>
                <Form.Label className='fw-medium mb-1' style={{ color: '#001529' }}>{'Password'}</Form.Label>
                <InputGroup className="" size="sm">
                  <InputGroup.Text id="password"><KeyRound size={18} /></InputGroup.Text>
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    className='login-input'
                    placeholder="Enter Your Password"
                    aria-label="Password"
                    aria-describedby="password"
                    name='password'
                    value={values.password || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <InputGroup.Text id="password" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </InputGroup.Text>
                </InputGroup>
                {errors.password && touched.password ? (<span className='field_error'>{errors.password}</span>) : null}
              </div>
            </div>
          </Card.Body>
          <Card.Footer className="text-muted d-flex justify-content-between align-items-center" style={{ backgroundColor: 'unset' }}>
            <span style={{ fontSize: '13px' }} className=''>By continuing, you agree to the <u className='teal' style={{ cursor: 'pointer' }}>terms of service</u> and <u className='teal' style={{ cursor: 'pointer' }}>privacy policy</u>.</span>
            <Button type='submit' size='sm' className='login_save_btn' disabled={spinner}>
              {spinner ?
                <ButtonLoader />
                :
                'Login'
              }
            </Button>
          </Card.Footer>
        </Card>
      </Form>
    </>
  )
}
